import { useForm } from '@inertiajs/react'
import type { FormEvent } from 'react'

import { AppShell } from '@/layouts/AppShell'
import { PageHeader } from '@/components/layout/PageHeader'
import { DiaryForm } from './components/DiaryForm'
import type { Breadcrumb } from '@/types/shared'
import type { DiaryFormData, DiaryFormOptions } from './types'

type Props = {
  diary: DiaryFormData
  options: DiaryFormOptions
  breadcrumbs: Breadcrumb[]
}

export default function Edit({ diary, options, breadcrumbs }: Props) {
  const { data, setData, errors, processing, put, transform } = useForm({
    diary_date: diary.diaryDate || '',
    activity_type: diary.activityType || '',
    concentration_rating: diary.concentrationRating?.toString() || '',
    attitude_rating: diary.attitudeRating?.toString() || '',
    understanding_rating: diary.understandingRating?.toString() || '',
    challenge_rating: diary.challengeRating?.toString() || '',
    continuity_rating: diary.continuityRating?.toString() || '',
    reflection: diary.reflection || '',
    training_content_ids: diary.trainingContentIds || [],
    diary_theme_ids: diary.diaryThemeIds || [],
  })

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    transform((current) => ({ soccer_diary: current }))
    put(`/player/soccer_diaries/${diary.id}`)
  }

  return (
    <AppShell>
      <PageHeader
        title="日記を編集"
        description="内容を修正して保存してください"
        breadcrumbs={breadcrumbs}
      />

      <DiaryForm
        data={data}
        setData={setData}
        errors={errors}
        processing={processing}
        options={options}
        onSubmit={handleSubmit}
        submitLabel="更新する"
        cancelHref={`/player/soccer_diaries/${diary.id}`}
      />
    </AppShell>
  )
}
